import { z } from 'zod';

import { isoDateTimeSchema, ulidSchema } from './primitives';

export const SUPPORTED_IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;
export const imageContentTypeSchema = z.enum(SUPPORTED_IMAGE_CONTENT_TYPES);
export type ImageContentType = z.infer<typeof imageContentTypeSchema>;

export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;

/** Persisted shape — never returned over the wire. The raw `s3Key` is in the public denylist. */
export const imageRefEntitySchema = z.object({
  imageId: ulidSchema,
  s3Key: z.string().min(1),
  contentType: imageContentTypeSchema,
  sizeBytes: z.number().int().nonnegative().max(MAX_IMAGE_SIZE_BYTES),
  uploadedAt: isoDateTimeSchema,
});
export type ImageRefEntity = z.infer<typeof imageRefEntitySchema>;

/** Wire shape — `url` constructed from `assetUrl(s3Key)`. Never includes `s3Key`. */
export const imageRefWireSchema = z.object({
  imageId: ulidSchema,
  url: z.string().url(),
  contentType: imageContentTypeSchema,
  sizeBytes: z.number().int().nonnegative(),
  uploadedAt: isoDateTimeSchema,
});
export type ImageRefWire = z.infer<typeof imageRefWireSchema>;

export const galleryCategorySchema = z.enum(['GLAMOUR', 'FOOD', 'INTERIOR']);
export type GalleryCategory = z.infer<typeof galleryCategorySchema>;

export const galleryImageEntitySchema = imageRefEntitySchema.extend({
  category: galleryCategorySchema,
  sortOrder: z.number().int().nonnegative(),
  caption: z.string().max(280).optional(),
});
export type GalleryImageEntity = z.infer<typeof galleryImageEntitySchema>;

export const galleryImageWireSchema = imageRefWireSchema.extend({
  category: galleryCategorySchema,
  sortOrder: z.number().int().nonnegative(),
  caption: z.string().max(280).optional(),
});
export type GalleryImageWire = z.infer<typeof galleryImageWireSchema>;
